import { combineReducers } from 'redux'
import host from './host'
import room from './room'
import rooms from './rooms'
import book from './book'
import books from './books'

export default combineReducers({ host, room, rooms, book, books })